<template>
  <div class="layout-wrapper">
    <div class="container-fluid">
      <button class="btn btn-info mx-3" @click="onPrintClicked">پرینت</button>
      <button class="btn btn-warning mx-3" @click="onBackClicked">بازگشت</button>
      <toggle-button class="mt-2 mx-3" @change="title1change1($event)" :labels="{unchecked: 'نمایش عنوان1', checked: 'نمایش عنوان1'}" :value="isActivet1" color="#82C7EB"
                     :width="92" :height="25" :sync="true"/>
      <toggle-button class="mt-2 mx-3" @change="title1change2($event)" :labels="{unchecked: 'نمایش عنوان2', checked: 'نمایش عنوان2'}" :value="isActivet2" color="#82C7EB"
                     :width="92" :height="25" :sync="true"/>
      <div class="row mt-3 " id="printMe" style="background-color: white">

        <div class="col-12 mt-5">
          <div class="row mx-2 p-2">
            <div class="col-3 text-center  align-self-center" style="max-height: 170px !important;">
              <div>
                <img src="../../public/img/print-logo.jpg" class="logo-img">
              </div>
            </div>
            <div class="col-6 bold font-weight-bold font-2xl text-center align-self-center">
              {{orderName}}
              {{app_name}}
            </div>
            <div class="col-3 text-left  align-self-center">
              <div class="row ">
              <span class="w-100 font-weight-bold">شماره سند :
              {{order.id}}</span>
              </div>
              <div class="row ">
              <span class="w-100">کاربر :
                {{username}} / {{company}} / {{post}} </span>
              </div>
            </div>
          </div>
        </div>
        <hr/>
        <div class="col-12 mt-3">
          <div class="row mx-2 p-2 border text-right">
            <div class="col-2">سفارش دهنده :</div>
            <div class="col-2 font-weight-bold">{{order.receiverName}}</div>
            <div class="col-2">تامین کننده :</div>
            <div class="col-2 font-weight-bold">{{order.serveName}}</div>
            <div class="col-2">تاریخ سفارش :</div>
            <div class="col-2 font-weight-bold">{{order.date}}</div>
          </div>
          <div class="row mx-2  p-2 border text-right">
            <div class="col-2">توضیحات سفارش :</div>
            <div class="col-6 font-weight-bold">{{order.description}}</div>
            <div class="col-2">کد سفارش :</div>
            <div class="col-2 font-weight-bold">{{order.code}}</div>
          </div>


        </div>
        <hr/>
        <div class="col-12 mt-5  ">
          <table class="table table-hover table-striped border text-center">
            <thead>
            <tr>
              <th class="text-center  border-right">ردیف</th>
              <th class="text-center  border-right">کد کالا</th>
              <th class="text-center  border-right">نام کالا</th>
              <th class="text-center  border-right" v-if="isActivet1">عنوان 1</th>
              <th class="text-center  border-right" v-if="isActivet2">عنوان 2</th>
              <th class="text-center  border-right">تعداد</th>
              <th class="text-center  border-right">واحد</th>
              <th class="text-center  border-right">تاریخ تحویل</th>
            </tr>

            </thead>
            <tbody>
            <tr v-for="(i, index) in order.orders">
              <td class="text-center   border-right text-nowrap">{{i.productId}}</td>
              <td class="text-center   border-right text-wrap">{{i.productCode}}</td>
              <td class="text-center   border-right text-wrap">{{i.productName}}</td>
              <td class="text-center   border-right text-wrap" v-if="isActivet1">{{i.title1}}</td>
              <td class="text-center   border-right text-wrap" v-if="isActivet2">{{i.title2}}</td>
              <td class="text-center   border-right text-nowrap">{{i.unitVal}}</td>
              <td class="text-center   border-right text-nowrap">{{i.unitName}}</td>
              <td class="text-center   border-right text-nowrap border-left">{{i.deliveryDate}}</td>

            </tr>

            </tbody>
          </table>

        </div>
        <hr/>
        <div class="col-12  ">
          <div class="row border mx-2  text-right">
            <div class="col-2 p-3 border-bottom">صادر کننده :</div>
            <div class="col-2 p-3 border-bottom font-weight-bold"></div>
            <div class="col-2 p-3 border-bottom border-right">تحویل گیرنده :</div>
            <div class="col-2 p-3 border-bottom font-weight-bold"></div>
            <div class="col-2 p-3 border-bottom border-right">مدیر :</div>
            <div class="col-2 p-3 border-bottom font-weight-bold"></div>

            <div class="col-4 p-3">محل امضاء :</div>
            <div class="col-4 p-3 border-right">محل امضاء :</div>
            <div class="col-4 p-3 border-right">محل مهر و امضاء :</div>

            <div class="col-4"><i style="visibility: hidden">www</i></div>
            <div class="col-4 border-right"><i style="visibility: hidden">www</i></div>
            <div class="col-4 border-right"><i style="visibility: hidden">www</i></div>
            <div class="col-4"><i style="visibility: hidden">www</i></div>
            <div class="col-4 border-right"><i style="visibility: hidden">www</i></div>
            <div class="col-4 border-right"><i style="visibility: hidden">www</i></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  .logo-img {
    max-height: 130px;
    max-width: 130px;

  }

  .rotated-text {
    /*-webkit-transform: rotate(-90deg);*/
    /*-ms-transform: rotate(-90deg);*/
    transform: rotate(-90deg);

    /*font-size: larger;*/
  }

  .print-style {
    direction: rtl !important;
    font-family: 'Shabnam';
    src: url('/font//Shabnam-FD.woff2') format('woff2'),
    url('/font/Shabnam-FD.woff') format('woff');
    font-weight: normal;
  }

</style>
<script>
  import BaseService from "../_framework/api/BaseService";
  import DatePicker from "../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import VsSelect from "../_framework/VsSelect";
  import Utils from "../_framework/utils/Utils";
  import Moment from 'moment-jalali';
  import VueHtmlToPaper from 'vue-html-to-paper';
  import Vue from 'vue';
  import Constants from "../Constants";
  import ToggleButton from "vue-js-toggle-button/src/Button";


  export default {
    name: "printOrder",
    components: {VsSelect, DatePicker, ToggleButton},
    data() {
      return {
        isBuyOrder: true, // 0 = moshtari 1 = kharid
        orderName: "سفارش مشتری شرکت ",
        cols: 5,
        company: "",
        post: "",
        username: "",
        app_name: "",
        mysampleSeris: [],
        sampleId: 0,
        serinum: 0,
        companyModel: {},
        ensampleAge: [],
        aver: 0,
        order: {},
        orderId: 0,
        isActive: true,
        isActivet1: true,
        isActivet2: true,
      }
    },
    mounted() {
      const printoptions = {
        name: '_blank',
        specs: [
          'fullscreen=yes',
          'titlebar=yes',
          'scrollbars=yes',

        ],
        styles: [
          './css/bootstrap4.min.css',
          './css/kidlat.css',
          './css/print-style.css',

        ],
        timeout: 10,
        autoClose: false,
        windowTitle: "پرینت سفارش"

      };
      Vue.use(VueHtmlToPaper, printoptions);

      this.app_name = Constants.APP_NAME;
      this.company = localStorage.getItem("company");
      this.post = localStorage.getItem("post");
      this.username = localStorage.getItem("username");

      if (this.$route.params.id !== undefined) {
        this.orderId = this.$route.params.id;
        this.getorderData();
      } else {

      }
      if (this.$route.params.isBuyOrder !== undefined) {
        if (this.$route.params.isBuyOrder === true) {
          this.isBuyOrder = true;
          this.orderName = "سفارش خرید شرکت ";
        } else {
          this.isBuyOrder = false;
          this.orderName = "سفارش مشتری شرکت ";
        }
      } else {
        this.isBuyOrder = false;
        this.orderName = "سفارش مشتری شرکت ";
      }
    },
    methods: {
      title1change1(e) {
        this.isActivet1 = !this.isActivet1;
      },
      title1change2(e) {
        this.isActivet2 = !this.isActivet2;
      },
      onBackClicked() {
        if (this.isBuyOrder) {
          this.$router.push({name: "سفارشات خرید-تامین"});
        } else {
          this.$router.push({name: "سفارشات مشتری"});
        }
      },
      onPrintClicked() {
        const title = document.title;
        document.title = "سفارش : " + this.order.id;
        this.$htmlToPaper('printMe');
        document.title = title;
      },
      getorderData() {
        new BaseService(`orders/${this.orderId}`).getList().then(response => {
          this.order = response.data;
          // const vouch = response.data;
          // for (let i of vouch.orders) {
          //   i.isoCode ="safsdfsf";
          //   new BaseService("orders/GetProductDetail").getById(i.productId).then(rs => {
          //     let details =  rs.data ;
          //     if(details.customerName !== null && details.customerName !== ""){
          //       i.productName = details.customerName;
          //     }
          //     i.isoCode =details.isoCode;
          //   });
          // }
          // this.order = vouch;
          console.log(this.order);
          console.log(this.order.orders);
          // let date = Moment(this.orderModel.orderDate, "jYYYY/jMM/jDD");
          // this.orderModel.orderDate = date.format("YYYY/MM/DD");
        }).catch(error => {
          console.log(error);
          Utils.handleErrorWithNotification(error.data, this.$noty);
        });
      },


    },

  }
</script>

<style lang="scss" scoped>
  .profile-image {
    margin: 0 auto 1rem auto;
  }

  .profile-image img {
    max-width: 150px;
    border-radius: 1rem;
    box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
  }
</style>
